import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "shop-form__block" }
const _hoisted_2 = {
  key: 0,
  class: "finish"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, " Мы отправили вам код на WhatsApp ", -1)
const _hoisted_4 = { class: "inputwrapper" }
const _hoisted_5 = {
  key: 0,
  class: "errorblock"
}
const _hoisted_6 = { class: "inputwrapper" }
const _hoisted_7 = {
  key: 0,
  class: "errorblock"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "confirm"
}
const _hoisted_10 = { class: "number" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "ready" }, "Подтверждено", -1)

import { computed, ref } from "vue";
import { useStore } from "vuex";
import { TypeLoyalityKinds } from "@/types";
import { IloyalityShopData } from "@/types/typesOfState";
import generateRandomString from "@/functions/generateRandomString";
import codeTimer from "@/components/code-timer.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'stepAuth',
  setup(__props, { expose: __expose }) {

const store = useStore();

const currentLoyalityKind = computed<TypeLoyalityKinds>(
  () => store.state.currentLoyalityKind
);

const loyalityShopData = computed<IloyalityShopData>(
  () => store.state.loyalityShopData
);

const lastBlockStep = computed<number>(() => store.state.lastBlockStep)
let invalidAuthPhone = ref(false);
let invalidAuthCode = ref(false);
const authPhoneInput = ref<any>(null);
const retryAfterCodeTimer = ref(0);

function nextAuthStep(isCodeAgain: boolean): void {
  const authPhone = store.state.authModule.authPhone;
  const authCode = store.state.authModule.authCode;

  switch (lastBlockStep.value) {
    case 0:
      if (!authPhone || authPhone.replace(" ", "").length < 15) {
        invalidAuthPhone.value = true;
        authPhoneInput?.value?.$el.focus();
      } else {
        store.state.authModule.authPassword = generateRandomString(5);
        invalidAuthPhone.value = false;
        store.dispatch("authByCode").then((data) => {
          retryAfterCodeTimer.value = data.data.result.retry_after;
          store.state.lastBlockStep++;
        });
      }
      break;
    case 1:
      if (!authCode || authCode.length < 4) {
        invalidAuthCode.value = true;
      } else {
        store
          .dispatch("authByCode")
          .then((data) => {
            console.log("authByCode", data, data.data, data.data.result);
            invalidAuthCode.value = false;
            if (data.data.result) {
              const tokens = data.data.result.token;
              store.state.authModule.tokens = tokens;
              store.state.currentShopStep++
              store.state.authCode = ''
            }
          })
          .catch((err) => {
            store.state.authModule.authCodeLoading = false;
            store.state.authCode = ''
            if (
              err.response.data.errors.non_field_errors[0] ===
              "Неправильный проверочный код"
            ) {
              invalidAuthCode.value = true;
              store.state.authModule.authCode = "";
            }
          });
      }
      break;
  }
}

function reSendCode():void {
  store.state.authModule.authCode = null
  store.dispatch("authByCode").then((data) => {
          retryAfterCodeTimer.value = data.data.result.retry_after;
        });
}

__expose({ nextAuthStep });

return (_ctx: any,_cache: any) => {
  const _component_MaskInput = _resolveComponent("MaskInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(store).state.authModule.tokens)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", {
            class: _normalizeClass({
          '_loader _loader-20px': _unref(store).state.authModule.authCodeLoading,
        })
          }, [
            _withDirectives(_createElementVNode("div", _hoisted_4, [
              (_unref(invalidAuthPhone))
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Перепроверьте номер"))
                : _createCommentVNode("", true),
              _createVNode(_component_MaskInput, {
                modelValue: _unref(store).state.authModule.authPhone,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).state.authModule.authPhone) = $event)),
                class: _normalizeClass([{ error: _unref(invalidAuthPhone) }, "input"]),
                ref_key: "authPhoneInput",
                ref: authPhoneInput,
                type: "tel",
                mask: 
              _unref(store).state.authModule.authPhone.includes('+7')
                ? '+# ### ### ## ##'
                : '+#############'
            ,
                placeholder: "+7 *** *** ** **"
              }, null, 8, ["modelValue", "class", "mask"])
            ], 512), [
              [_vShow, lastBlockStep.value === 0 && lastBlockStep.value !== 2]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_6, [
              (_unref(invalidAuthCode))
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Неверный код"))
                : _createCommentVNode("", true),
              _createVNode(_component_MaskInput, {
                mask: "# # # #",
                modelValue: _unref(store).state.authModule.authCode,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(store).state.authModule.authCode) = $event)),
                class: _normalizeClass([{ error: _unref(invalidAuthCode) }, "input"]),
                placeholder: "Введите код"
              }, null, 8, ["modelValue", "class"])
            ], 512), [
              [_vShow, lastBlockStep.value === 1 && lastBlockStep.value !== 2]
            ]),
            (lastBlockStep.value !== 2)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button bezh",
                  onClick: nextAuthStep
                }, _toDisplayString(lastBlockStep.value === 0 ? "Запросить код" : "Подтвердить"), 1))
              : _createCommentVNode("", true)
          ], 2),
          (lastBlockStep.value === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(codeTimer, { retryAfter: retryAfterCodeTimer.value }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      class: "button bezh",
                      onClick: reSendCode
                    }, " Запросить код повторно ")
                  ]),
                  _: 1
                }, 8, ["retryAfter"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(store).state.authModule.authPhone), 1),
          _hoisted_11
        ]))
  ]))
}
}

})